import { RBACPermissions } from './rbac-types';
import { UserRoles } from '../../shared/types/generated';


export const RBACSchema = [
  {
    Role: UserRoles.Master,
    Permissions: [
      RBACPermissions.USERS, RBACPermissions.STRATEGIES, RBACPermissions.RISKS, RBACPermissions.PAIRS, RBACPermissions.ORDER_ACTIVITY_ACTION, RBACPermissions.BUILD, RBACPermissions.FLUSH],
  },
  {
    Role: UserRoles.User,
    Permissions: [],
  },
];
